'use client';

import { useEffect, useSyncExternalStore } from 'react';
import { getRealtimeClient } from './client-manager';
import { useServerRenderTimestamp } from './server-render-timestamp';

export function useRealtime() {
    const client = getRealtimeClient();
    const { streamId } = useServerRenderTimestamp();

    // Initialize on mount with server render timestamp
    useEffect(() => {
        client.init(streamId);
    }, [client, streamId]);

    // Subscribe to status changes using useSyncExternalStore
    const status = useSyncExternalStore(
        (callback) => {
            return client.subscribe(() => {
                callback();
            });
        },
        () => client.getStatus(),
        () => 'disconnected', // Server-side default
    );

    return {
        status,
        send: client.send.bind(client),
        subscribe: client.subscribe.bind(client),
        joinRoom: client.joinRoom.bind(client),
        rawSocket: client.rawSocket,
    };
}
